<template>
  <GenericDataView
    v-slot="{id, loading, isUpdateForm}"
    title="Cost Pools"
    local-storage-key="costPools"
    :state="costPools"
    :read="costPoolsStore.readCostPools"
    :set="costPoolsStore.setCostPools"
    :delete="costPoolsStore.deleteCostPool"
    :cols-map="colsMap"
    :cached="cached"
    @cached="cached = true"
  >
    <CostPoolForm :id="id" :loading="loading" :is-update-form="isUpdateForm" />
  </GenericDataView>
</template>
<script setup lang="ts">
import {CostPool} from '@/stores/userManagement/userManagement';

const costPoolsStore = useCostPoolsStore();
const {costPools} = storeToRefs(costPoolsStore);
const cached = ref(false);

const colsMap = readonly<{[key: string]: keyof CostPool}>({
  'Cost Pool Name': 'name',
  'Cost Pool Type': 'type',
  'Cost Pool Description': 'description',
});
</script>
